import { fetchData } from "./fetchData";

export const getFightByID = async (fightID) => {
  try {
    const route = `/fights/${fightID}`;

    const options = {
      method: "GET",
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getAllFights = async (query) => {
  try {
    const route = `/fights${query}`;

    const options = {
      method: "GET",
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const createFight = async (formData) => {
  try {
    const route = `/fights`;

    const options = {
      method: "POST",
      Headers: {
        "Content-Type": "application/json",
      },
      body: formData,
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getRecentFights = async (limit = 6) => {
  try {
    const route = `/fights/recent?limit=${limit}`;
    const options = { method: "GET" };
    let response = await fetchData(route, options);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getTopVotedFights = async (limit = 5) => {
  try {
    const route = `/fights/top-voted?limit=${limit}`;
    const options = { method: "GET" };
    let response = await fetchData(route, options);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const updateFight = async (fightID, data) => {
  try {
    const route = `/fights/${fightID}`;

    const options = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: data,
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteFight = async (fightID) => {
  try {
    const route = `/fights/${fightID}`;

    const options = {
      method: "DELETE",
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};
